import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@mui/material';
import * as Styled from '../LoyaltyPageReport.styles';
import { selectors } from '../../LoyaltyPage/reducer';

const CurrentParametersTable = () => {
  const { t } = useTranslation();
  const loyaltyPercentages = useSelector(selectors.loyaltyPercentages);
  const integrationCode = process.env.REACT_APP_INTEGRATION_NETWORK;

  return (
    <Styled.CurrentParametersBlock>
      <Table sx={{ width: 'fit-content' }}>
        <TableHead>
          <TableRow>
            <TableCell className="header-cell">
              {t('LoyaltyPageReport.PARAMETERS')}
            </TableCell>
            <TableCell className="header-cell">
              {t('LoyaltyPageReport.BONUSES')}
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell>{t('LoyaltyPageReport.INTEGRATION_CODE')}</TableCell>
            <TableCell>{integrationCode}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>{t('LoyaltyPageReport.BASE_BONUS')}</TableCell>
            <TableCell>
              {loyaltyPercentages?.items_check_percent
                ? `${loyaltyPercentages?.items_check_percent}%`
                : '-'}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>{t('LoyaltyPageReport.MAX_BONUS_DISCOUNT')}</TableCell>
            <TableCell>
              {loyaltyPercentages?.items_cover_percent
                ? `${loyaltyPercentages?.items_cover_percent}%`
                : '-'}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>{t('LoyaltyPageReport.PHARMACIST_BONUS')}</TableCell>
            <TableCell>
              {loyaltyPercentages?.pharmacist_percent
                ? `${loyaltyPercentages?.pharmacist_percent}%`
                : '-'}
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </Styled.CurrentParametersBlock>
  );
};

export default CurrentParametersTable;
